import React, { Component } from 'react';
import './App.css';
import { Switch, Route } from 'react-router-dom';
import Contact from './pages/Contact/Contact';
import NotFound from './pages/NotFound/NotFound';
import Register from './pages/Register/Register';
import { Provider } from 'react-redux';
import Store from './Store';
import Home from './pages/Home/Home';
import Login from './pages/Login/Login';
import Communicate from './pages/Communicate/Communicate';
import Stats from './pages/Stats/Stats';
import Reports from './pages/Reports/Reports';
import GoogleMaps from './pages/Map/Map';
import Graphs from './shared/Graphs';
import Emails from './shared/Emails';
import TestUsers from './pages/TestUsers/TestUsers';
import Incentives from './pages/Incentives/Incentives';






class App extends Component {

    render() {

        return (
            <div className="App">
                <Provider store={Store}>
                    <Switch>
                      <Route path='/contact' component={Contact}/>
                        <Route path='/map' component={GoogleMaps}/>
                        <Route path='/communicate' component={Communicate}/>
                        <Route path='/stats' component={Emails}/>
                        <Route path='/reports' component={Reports}/>
                        <Route path='/testusers' component={TestUsers}/>
                        <Route path='/incentives' component={Incentives}/>
                        <Route path="/schedule/:number" component={NotFound}/>
                        <Route path='/schedule' component={NotFound}/>
                        <Route path='/register' component={Register} />
                        <Route path='/login' component={Login} />
                        <Route path='/graphs' component={Graphs} />
                        <Route path='/' component={Stats}/>
                    </Switch>
                </Provider>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js